import { __awaiter } from "tslib";
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { components as clientComponents } from 'mage-client';
import { MOET_CONSTANTS } from 'moet-core';
import { Message } from 'mage-i18n';
import { Strong, IconFile, Link, ListTertiary, SpacerHorizontal, SpacerVertical, Typography, } from '@klarna/bubble-ui';
import { CAPS } from '@/constants';
import { AttachmentType } from '@/constants/documents';
import { getWidgetTypeFromWidgetCookie } from '@/selectors/widget';
import { getMerchantAwareTranslator, getMerchantAwareTranslationKey, getMerchantAwareArrayTranslator, getUserMerchantId, merchantRegion, } from '@/selectors/merchant';
import { tPrefix, ICON_MAP } from './constants';
import Uploader from './Uploader';
import Viewer from './Viewer';
import { logEvent } from '@/utils/analytics';
import { ANALYTICS_EVENTS } from './analyticsEvents';
import { CY_DOCUMENTS_CONTAINER_IDS } from '@/containers/Documents/constants';
import { Container, Header, TitleAndDescription } from './styledComponents';
const { WIDGET_TYPE } = MOET_CONSTANTS;
const DocumentUploadComponent = ({ t, tArray, tKey, type = AttachmentType.SUPPORTING_DOCUMENT, documents, metadata, mid, region, required, isDocumentUpload, listDocumentsWidget, listDocumentsNonWidget, deleteDocument, uploadDocument, }) => {
    var _a, _b;
    const [errors, setErrors] = useState([]);
    const roles = ((_a = metadata.stakeholderRoles) === null || _a === void 0 ? void 0 : _a.length)
        ? `_${(_b = metadata.stakeholderRoles) === null || _b === void 0 ? void 0 : _b.toString()}`
        : '';
    const listDocuments = isDocumentUpload ? listDocumentsWidget : listDocumentsNonWidget;
    const Icon = ICON_MAP[type] || IconFile;
    const onDeleteDocument = useCallback((doc, callback) => {
        const removeDocument = () => __awaiter(void 0, void 0, void 0, function* () {
            yield deleteDocument({ params: { mid, attachmentId: doc.attachmentId }, region });
            yield listDocuments({ params: { mid }, region });
            logEvent(ANALYTICS_EVENTS.deleteDocument, { documentType: doc === null || doc === void 0 ? void 0 : doc.type });
            callback();
            setErrors(null);
        });
        if (documents === null || documents === void 0 ? void 0 : documents.length) {
            removeDocument();
        }
    }, [documents, deleteDocument, listDocuments]);
    const onUploadDocument = useCallback((fileForm_1, _c) => __awaiter(void 0, [fileForm_1, _c], void 0, function* (fileForm, { onUploadProgress }) {
        yield uploadDocument({
            params: Object.assign({ mid,
                type }, (metadata.stakeholderId ? { stakeholderId: metadata.stakeholderId } : {})),
            body: fileForm,
            region,
            onUploadProgress,
        });
        yield listDocuments({ params: { mid }, region });
    }), [metadata, uploadDocument, listDocuments]);
    const tPrefixExplanation = `${tPrefix}.explanation.${type}`;
    const explanationList = tArray(`${tPrefixExplanation}.list`);
    const strong = value => React.createElement(Strong, null, value);
    const link = (value) => {
        const href = t(`${tPrefixExplanation}.link`);
        return href ? (React.createElement(Link, { href: href, target: "_blank" }, value)) : (value);
    };
    return (React.createElement(Container, null,
        React.createElement(Header, null,
            React.createElement(Icon, { style: { minWidth: '20px' }, customSize: 20 }),
            React.createElement(SpacerHorizontal, { medium: true }),
            React.createElement(TitleAndDescription, null,
                React.createElement(Typography, { align: "start", textToken: "text-style/text/labels/body/bold" },
                    t(`${tPrefixExplanation}.title`) || type,
                    ' ',
                    !required && (React.createElement(Typography, { align: "start", textToken: "text-style/text/labels/body/regular" }, t(`${tPrefix}.optional`)))),
                React.createElement(SpacerHorizontal, { extraSmall: true }),
                React.createElement(Typography, { align: "start", colorToken: "colors/text/neutral", textToken: "text-style/text/paragraphs/default/regular" },
                    React.createElement(Message, { path: tKey(`${tPrefixExplanation}.subtitle`), params: { link, strong } })),
                explanationList && Array.isArray(explanationList) && (React.createElement(ListTertiary, { items: explanationList.map(r => (React.createElement(Typography
                    // @ts-expect-error: FIXME
                    , { 
                        // @ts-expect-error: FIXME
                        key: r.text, align: "start", colorToken: "colors/text/neutral", textToken: "text-style/text/paragraphs/default/regular" }, r.text))) })))),
        React.createElement(SpacerVertical, { small: true }),
        React.createElement(Uploader, { type: type, onUploadDocument: onUploadDocument, cyElementId: CY_DOCUMENTS_CONTAINER_IDS.BUTTON_BROWSE_FILES + `_${type}` + `${roles}`, errors: errors, setErrors: setErrors }),
        documents && (React.createElement(Viewer, { documents: documents, onDeleteDocument: onDeleteDocument, "data-testid": "viewer" }))));
};
export const DocumentUpload = compose(connect(state => ({
    isDocumentUpload: getWidgetTypeFromWidgetCookie(state) === WIDGET_TYPE.DOCUMENT_UPLOAD,
    mid: getUserMerchantId(state),
    region: merchantRegion(state),
    t: getMerchantAwareTranslator(state),
    tArray: getMerchantAwareArrayTranslator(state),
    tKey: getMerchantAwareTranslationKey(state),
})), 
// @ts-expect-error: FIXME
clientComponents.withPromiseBasedCapabilities({
    deleteDocument: CAPS.V2_DOC_DELETE,
    listDocumentsNonWidget: CAPS.V2_DOC_LIST,
    listDocumentsWidget: CAPS.V2_DOC_TOKEN_INFO,
    uploadDocument: CAPS.V2_DOC_UPLOAD,
}))(DocumentUploadComponent);
